import React, { useEffect, useState } from 'react';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer, Typography,
    TableRow, Autocomplete, TextareaAutosize, Checkbox

} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { selectFirm, selectParty, selectSchool, selectTransports } from '../Selectors/Master/ItemSelectors';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { fetchPartyData } from '../../Store/PHPSlice/Party';
import { fetchTransportData } from '../../Store/PHPSlice/Transport';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import Dropdown from '../FieldsComponents/Dropdown';
import TextareaComponent from '../FieldsComponents/TextareaComponent';
import { fetchSchoolData } from '../../Store/PHPSlice/School';
import { fetchPackingData, fetchStkOnlyManualbarcode, fetchStkOrderManualbarcode, insertPackingEntry } from '../../Store/PHPSlice/Packing/PackApis';
import { selectPackingData, selectStkOnlyManualnos, selectStkOrderManualnos } from '../Selectors/PackSelector/PackingSelector';
import axios from 'axios';
import RadioComponent from '../FieldsComponents/RadioComponent';
import { useParams } from 'react-router-dom';


const PackingEdit = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        dt: '',
        barcode: '',
        eType: '',
        pkMemo: '',
        baleNo: '',
        firm: '',
        party: '',
        adrs: '',
        trspt: '',
        shtoNm: '',
        shtoadrs: '',
        parcelqty: '',
        remark: '',
        item: '',
        schlNm: '',
        totQty: '',
        ordMan: '',
        userId: userdata?.ID
    });
    const [packData, setPackData] = useState([]);
    const [prevPackData, setPrevPackData] = useState([]);
    const [addItems, setAddItems] = useState(false);
    const [updateItems, setUpdateItems] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const dispatch = useDispatch();
    const firmlist = useSelector(selectFirm);
    const partylist = useSelector(selectParty);
    const transportlist = useSelector(selectTransports);
    const schlist = useSelector(selectSchool);

    const stkOrdManualnos = useSelector(selectStkOrderManualnos);
    const stkOnlyManualnos = useSelector(selectStkOnlyManualnos);
    const baseUrl = process.env.REACT_APP_BASE_URL;

    const singlePack = useSelector(selectPackingData);
    // console.log(singlePack)
    useEffect(() => {
        dispatch(fetchPackingData(Id));
    }, [Id])

    useEffect(() => {
        dispatch(fetchCompanyData());
        dispatch(fetchPartyData());
        dispatch(fetchTransportData());
        dispatch(fetchSchoolData());
        dispatch(fetchStkOrderManualbarcode());
        dispatch(fetchStkOnlyManualbarcode());
    }, [dispatch]);

    useEffect(() => {
        if (singlePack?.data) {
            const item = singlePack?.data;
            setFormData(prev => ({
                ...prev,
                adrs: item.adrs,
                dt: item.DT,
                eType: item.eType,
                firm: item.firmId,
                parcelqty: item.parcel_qty,
                party: item.partyId,
                pkMemo: item.pkMemo,
                remark: item.remark,
                schlNm: item.schlId,
                shtoNm: item.shipNm,
                shtoadrs: item.ship_adrs,
                totQty: item.totqty,
                totamt: item.totamt,
                trspt: item.transptId,
                firmAdrs: item.firmAdrs,
                gst: item.gst
            }));
        }
        if (singlePack?.Info && singlePack.Info?.length > 0) {
            const info = singlePack.Info;
            setPrevPackData(info);
        }
    }, [singlePack]);

    const isDesktop = useMediaQuery('(min-width:768px)');
    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };

    const handleDropdownChange = async (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });

        if (dropdownType === 'ordMan' && value) {
            setFormData(prev => ({
                ...prev,
                ordMan: '' // Reset to clear the field
            }));
            fetchSktSingleRecords(value);
            setSelectedItems(prev => [...prev, value]);

        }
    };

    const handleQuantityChange = (index, name, value) => {
        // Make a copy of packData
        const updatedPackData = [...packData];

        // Ensure the value is a valid number
        const newValue = parseFloat(value) || 0;

        // Update either rate or qty based on the input field
        if (name === "rate") {
            updatedPackData[index].rate = newValue;
        } else if (name === "qty") {
            // If entered qty is greater than stkqty, set qty to stkqty
            const stkqty = updatedPackData[index].stkqty || 0; // Ensure stkqty is a number
            if (newValue > stkqty) {
                updatedPackData[index].qty = stkqty; // Set qty to stkqty if the entered value exceeds stkqty
            } else {
                updatedPackData[index].qty = newValue; // Otherwise, set qty to entered value
            }
        }

        // Recalculate totalqty (total = rate * qty)
        const qty = updatedPackData[index].qty || 0;  // Ensure qty is a number
        const rate = updatedPackData[index].rate || 0;  // Ensure rate is a number
        updatedPackData[index].totalqty = qty * rate;

        // Handle balqty logic based on stkqty and qty
        const stkqty = updatedPackData[index].stkqty || 0; // Ensure stkqty is a number
        let balqty = 0;
        if (qty > stkqty) {
            // If entered qty is more than stkqty, set balqty to stkqty
            balqty = stkqty;
        } else {
            // Otherwise, set balqty to stkqty - qty
            balqty = stkqty - qty;
        }

        updatedPackData[index].balqty = balqty;

        const totalQty = updatedPackData.reduce((sum, item) => sum + (item.qty || 0), 0);

        // Update state
        setPackData(updatedPackData);
        setFormData(prev => ({
            ...prev,
            totQty: totalQty
        }));
    };

    const handleSelectChange = (index) => {
        // Toggle selection for the row at the given index
        setSelectedRows((prevSelectedRows) => {
            if (prevSelectedRows.includes(index)) {
                // If already selected, remove it from the array
                return prevSelectedRows.filter(item => item !== index);
            } else {
                // Otherwise, add it to the array
                return [...prevSelectedRows, index];
            }
        });
    };

    const handleDelete = () => {
        // Step 1: Remove selected items from packData
        setPackData((prevPackData) => {
            const newPackData = prevPackData.filter((item, index) => !selectedRows.includes(index));

            // Step 2: Remove the corresponding items from selectedItems
            setSelectedItems((prevSelectedItems) => {
                // Find the IDs of the items to be removed (those in selectedRows)
                const itemsToRemove = selectedRows
                    .map(index => prevPackData[index]?.ID) // Get the IDs of the items in selectedRows
                    .filter(id => id !== undefined); // Filter out undefined values (in case the index is invalid)

                // Remove these IDs from selectedItems
                return prevSelectedItems.filter(id => !itemsToRemove.includes(id));
            });

            return newPackData;
        });

        // Step 3: Clear selected rows after deletion
        setSelectedRows([]);
    };
    const handleRadioChange = (event) => {
        setFormData({
            ...formData,
            [event.target.name]: event.target.value,
        });
    };

    const fetchSktSingleRecords = async (id) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getStkDataSingleRecord&stkId=${id}`);
            let itemData = response.data.data;
            // Add new keys with the specified values
            itemData = {
                ...itemData,
                balqty: itemData.stkqty || 0,  // balqty is the same as stkqty, or 0 if undefined
                qty: 0,  // default value for qty
                totalqty: 0,  // default value for total
                rate: 0  // default value for rate
            };
            setPackData(prev => Array.isArray(prev) ? [...prev, itemData] : [itemData]);
        } catch (error) {
            console.error('Error fetching title list:', error);
            setPackData([]);
        }
    };

    const fields = [
        { label: 'Date', name: 'dt', type: 'date' },
        { label: 'Packing Slip Memo', name: 'pkMemo', type: 'readOnly' }
    ];

    const dropdownlistfirst = [
        {
            label: 'Firm',
            id: 'firm',
            options: firmlist?.data,
            value: formData.firm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'firm', value: newValue ? newValue.ID : '' } }, 'firm'),
            getOptionLabel: (option) => option.firmNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        },
        {
            label: 'Party',
            id: 'party',
            options: partylist?.data,
            value: formData.party,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'party', value: newValue ? newValue.ID : '' } }, 'party'),
            getOptionLabel: (option) => option.partyNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];

    const dropdownlistsecond = [
        {
            label: 'Transport',
            id: 'trspt',
            options: transportlist?.data,
            value: formData.trspt,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'trspt', value: newValue ? newValue.ID : '' } }, 'trspt'),
            getOptionLabel: (option) => option.transportNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        },
        {
            label: 'School',
            id: 'schlNm',
            options: schlist?.data,
            value: formData.schlNm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'schlNm', value: newValue ? newValue.ID : '' } }, 'schlNm'),
            getOptionLabel: (option) => option.schoolNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];

    const filterSelectedItems = (options) => {
        return options.filter(option => !selectedItems.includes(option.ID));
    };

    const ItemConfig = {
        '1': {
            label: 'Item',
            id: 'ordMan',
            options: filterSelectedItems(stkOrdManualnos?.data),
            value: formData.ordMan || '',
            onChange: (newValue) => handleDropdownChange({ target: { name: 'ordMan', value: newValue ? newValue.ID : '' } }, 'ordMan'),
            getOptionLabel: (option) => option.order_no || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        },
        '2': {
            label: 'Item',
            id: 'ordMan',
            options: filterSelectedItems(stkOnlyManualnos?.data),
            value: formData.ordMan || '',
            onChange: (newValue) => handleDropdownChange({ target: { name: 'ordMan', value: newValue ? newValue.ID : '' } }, 'ordMan'),
            getOptionLabel: (option) => option.order_no || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    };

    const dropdownlistthird = ItemConfig[formData.eType];

    const adrss = [
        { label: 'Address', name: 'adrs' },
    ];

    const fieldsecond = [
        { label: 'Ship To Name', name: 'shtoNm' },
        { label: 'Ship To Address', name: 'shtoadrs' },
        { label: 'Parcel Qty', name: 'parcelqty' },
        { label: 'Remark', name: 'remark' },
        { label: 'Total Qty', name: 'totQty', type: 'readOnly' }
    ];

    const options = [
        { value: '1', label: 'Order + Manual' },
        { value: '2', label: 'Manual' },
    ];

    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };

    function object(formData, packData) {
        const data = {
            dt: formData.dt,
            eType: formData.eType,
            pkMemo: formData.pkMemo,
            firmId: formData.firm,
            partyId: formData.party,
            adrs: formData.adrs,
            trnsptId: formData.trspt,
            schlId: formData.schlNm,
            shipNm: formData.shtoNm,
            ship_adrs: formData.shtoadrs,
            parcelqty: formData.parcelqty,
            remark: formData.remark,
            totqty: formData.totQty,
            userId: formData.userId,
            packData: packData
        };
        return data;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // const validationErrors = validate();
        // if (Object.keys(validationErrors).length > 0) {
        //     setErrors(validationErrors);
        //     return;
        // }
        const finalObject = object(formData, packData);
        // console.log(finalObject)

        dispatch(insertPackingEntry(finalObject))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("Records Inserted");
                window.location.reload();
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });
    };
    return (
        <>

            <div style={{ margin: '1% 0.5%' }}>
                <div style={{ display: 'flex', gap: '5vh' }}>
                    <h2>Packing Edit</h2>

                </div>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {fields.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                {
                                    dropdownlistfirst && dropdownlistfirst.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                {adrss.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                {
                                    dropdownlistsecond && dropdownlistsecond.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                {/* <TextareaComponent
                                    label="Naration"
                                    name="nartn"
                                    value={formData.nartn}
                                    onChange={handleInputChange}
                                    isDesktop={isDesktop}
                                /> */}

                                {fieldsecond.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                <Grid item xs={6} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={() => setUpdateItems(!updateItems)}>Previous Items</Button>
                                </Grid>

                                <Grid item xs={6} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={() => setAddItems(!addItems)}>Add Items</Button>
                                </Grid>


                                {updateItems == true &&
                                    <>


                                        {/* <Grid item xs={6}>
                                            <Button variant="contained" color="primary" size='small' disabled={selectedRows.length === 0} onClick={handleDelete}>Delete</Button>
                                        </Grid> */}

                                        {Array.isArray(prevPackData) && prevPackData.length > 0 &&

                                            <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                                <Table style={isDesktop ? { width: '100%' } : { width: '100%' }}>
                                                    <TableBody>

                                                        <TableRow>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>
                                                                {/* <input
                                                                    type="checkbox"
                                                                    onChange={() => {
                                                                        // Select all checkboxes when the header checkbox is toggled
                                                                        if (selectedRows.length === prevPackData.length) {
                                                                            setSelectedRows([]); // Deselect all if already selected
                                                                        } else {
                                                                            setSelectedRows(prevPackData.map((_, index) => index)); // Select all
                                                                        }
                                                                    }}
                                                                    checked={selectedRows.length === prevPackData.length}
                                                                />Select */}
                                                                Select
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Sr.No.</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Item</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Size</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Stock Qty.</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Prev. Qty</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Qty.</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Prev. Rate</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Rate</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Total</TableCell>
                                                        </TableRow>
                                                        {
                                                            prevPackData.map((item, index) => (
                                                                <TableRow key={index}>

                                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={selectedRows.includes(index)}
                                                                            onChange={() => handleSelectChange(index)}
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{index + 1}</TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.itemNm}</TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.size}</TableCell>

                                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.actqty}</TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                        <input
                                                                            type="text"
                                                                            value={item.qty || '0'}  // Ensure value is either the number or an empty string
                                                                            name="qty"
                                                                            style={{ width: '50px', padding: '1px' }}
                                                                            max={item.qty}
                                                                            readOnly
                                                                            // onChange={(e) => handleQuantityChange(index, 'qty', e.target.value)}  // Handle qty change
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                        <input
                                                                            type="text"
                                                                            value={item.newqty || '0'}  // Show balance qty
                                                                            name="newqty"
                                                                            style={{ width: '50px', padding: '1px' }}
                                                                            readOnly
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                        <input
                                                                            type="text"
                                                                            value={item.rate || '0'}  // Ensure value is either the number or an empty string
                                                                            name="rate"
                                                                            style={{ width: '50px', padding: '1px' }}
                                                                            // onChange={(e) => handleQuantityChange(index, 'rate', e.target.value)}  // Handle rate change
                                                                            readOnly
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                        <input
                                                                            type="text"
                                                                            value={item.newrate || '0'}  // Ensure value is either the number or an empty string
                                                                            name="newrate"
                                                                            style={{ width: '50px', padding: '1px' }}
                                                                            // onChange={(e) => handleQuantityChange(index, 'rate', e.target.value)}  // Handle rate change
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                        <input
                                                                            type="text"
                                                                            value={item.tot || '0'}  // Show total qty
                                                                            name="tot"
                                                                            style={{ width: '50px', padding: '1px' }}
                                                                            readOnly
                                                                        />
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))
                                                        }
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>

                                        }
                                    </>

                                }

                                {addItems == true &&
                                    <>
                                        <RadioComponent
                                            label='Packing'
                                            name="eType"
                                            value={formData.eType}
                                            options={options}
                                            onChange={handleRadioChange}
                                            isDesktop={true} // Pass the actual value based on screen size
                                        />

                                        <Grid item xs={6} textAlign="center">

                                        </Grid>

                                        {
                                            dropdownlistthird &&
                                            <Dropdown
                                                key={dropdownlistthird.label}
                                                label={dropdownlistthird.label}
                                                id={dropdownlistthird.id}
                                                options={dropdownlistthird.options}
                                                value={dropdownlistthird.value}
                                                onChange={dropdownlistthird.onChange}
                                                isDesktop={isDesktop}
                                                getOptionLabel={dropdownlistthird.getOptionLabel}
                                                isOptionEqualToValue={dropdownlistthird.isOptionEqualToValue}
                                                valueFinder={dropdownlistthird.valueFinder}  // Pass `valueFinder` function here
                                            />

                                        }


                                        <Grid item xs={6}>
                                            <Button variant="contained" color="primary" size='small' disabled={selectedRows.length === 0} onClick={handleDelete}>Delete</Button>
                                        </Grid>

                                        {Array.isArray(packData) && packData.length > 0 &&

                                            <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                                <Table style={isDesktop ? { width: '100%' } : { width: '100%' }}>
                                                    <TableBody>

                                                        <TableRow>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>
                                                                <input
                                                                    type="checkbox"
                                                                    onChange={() => {
                                                                        // Select all checkboxes when the header checkbox is toggled
                                                                        if (selectedRows.length === packData.length) {
                                                                            setSelectedRows([]); // Deselect all if already selected
                                                                        } else {
                                                                            setSelectedRows(packData.map((_, index) => index)); // Select all
                                                                        }
                                                                    }}
                                                                    checked={selectedRows.length === packData.length}
                                                                />Select
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Sr.No.</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Item</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Size</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Rate</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Stock Qty.</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Qty</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Balance Qty.</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Total Qty.</TableCell>
                                                        </TableRow>
                                                        {
                                                            packData.map((item, index) => (
                                                                <TableRow key={index}>

                                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={selectedRows.includes(index)}
                                                                            onChange={() => handleSelectChange(index)}
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{index + 1}</TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.order_no}</TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.size}</TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                        <input
                                                                            type="text"
                                                                            value={item.rate || '0'}  // Ensure value is either the number or an empty string
                                                                            name="rate"
                                                                            style={{ width: '50px', padding: '1px' }}
                                                                            onChange={(e) => handleQuantityChange(index, 'rate', e.target.value)}  // Handle rate change
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.stkqty}</TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                        <input
                                                                            type="text"
                                                                            value={item.qty || '0'}  // Ensure value is either the number or an empty string
                                                                            name="qty"
                                                                            style={{ width: '50px', padding: '1px' }}
                                                                            max={item.stkqty}
                                                                            onChange={(e) => handleQuantityChange(index, 'qty', e.target.value)}  // Handle qty change
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                        <input
                                                                            type="text"
                                                                            value={item.balqty || '0'}  // Show balance qty
                                                                            name="balqty"
                                                                            style={{ width: '50px', padding: '1px' }}
                                                                            readOnly
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                        <input
                                                                            type="text"
                                                                            value={item.totalqty || '0'}  // Show total qty
                                                                            name="totalqty"
                                                                            style={{ width: '50px', padding: '1px' }}
                                                                            readOnly
                                                                        />
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))
                                                        }
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>

                                        }
                                    </>

                                }

                                {/* <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={packData.length === 0}>Submit</Button>
                                </Grid> */}

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default PackingEdit;
